<template>
  <div>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding"
        cols="12"
      >
        <VTextField
          v-model="name"
          outlined
          :label="$t('forms.labels.name')"
          :rules="{ required: true, min: 1, max: 20 }"
          data-cy="apiKeyAddName"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding"
        cols="12"
      >
        <VTextField
          v-model="description"
          outlined
          :label="$t('forms.labels.description')"
          :rules="{ required: false, min: 1, max: 200 }"
          data-cy="apiKeyAddDescription"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';


export default {
    components: {
        VTextField,
    },
    props: {
        isEdition: {
            type: Boolean,
            default: false,
        },
        apiItem: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            name: '',
            description: '',
        };
    },
    created() {
        if (this.isEdition) {
            this.name = this.apiItem.name;
            this.description = this.apiItem.description;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', {
                name: this.name,
                description: this.description,
            });
        },
    },
};


</script>
